<div class="recently__touched__container" fxFlex fxLayout="column" fxLayoutGap=".5rem">
  <h2>Recently Accessed</h2>
  <form [formGroup]="filterForm" fxFlex fxLayout="row" fxLayoutGap=".5rem">
    <mat-form-field>
      <mat-label>Show</mat-label>
      <mat-select formControlName="showRecordControl">
        <mat-option *ngFor="let show of showTypes" [value]="show"> {{ show }} </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
  <div class="recently__touched__card__container">
    <ng-container *ngIf="patientRecentlyTouched$ | async as patients">
      <ng-container *ngFor="let patient of patients">
        <mat-expansion-panel class="recently__touched__card" *ngIf="patient.dates.length > 1; else singleCard">
          <mat-expansion-panel-header>
            <mat-panel-title class="cursor-pointer" (click)="viewPatient('patient-detail', patient.patientId, $event)">
              <h3>{{ patient.patientName }}</h3>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ul>
            <li *ngFor="let date of patient.dates">
              {{ date | date: 'short' }}
            </li>
          </ul>
        </mat-expansion-panel>

        <ng-template #singleCard>
          <mat-card class="recently__touched__card">
            <mat-card-title
              class="cursor-pointer"
              color="primary"
              (click)="viewPatient('patient-detail', patient.patientId, $event)"
              >{{ patient.patientName }}</mat-card-title
            >
            <mat-card-content>
              {{ patient.dates[0] | date: 'short' }}
            </mat-card-content>
          </mat-card>
        </ng-template>
      </ng-container>
    </ng-container>
  </div>
</div>
